module.exports = __webpack_public_path__ + "img/jingmo.71a57c1a.jpg";